import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.docs.history');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-docs-history',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.docs.history/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
  background: #ffffff;
}

.history-wrap {
  width: min(100%, 1180px);
  margin: 0 auto;
  padding: 0 20px;
}

.history-topbar {
  margin-bottom: 20px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(16px);
  box-shadow: 0 20px 48px rgba(148, 163, 184, 0.1);
}

.history-topbar__inner {
  padding: 24px 28px;
}

.history-kicker {
  display: inline-flex;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(226, 232, 240, 0.9);
  color: #6366f1;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.history-title {
  margin: 12px 0 0;
  color: #0f172a;
  font-size: 30px;
  line-height: 1.08;
  letter-spacing: -0.04em;
  font-weight: 700;
}

.history-subtitle {
  margin: 10px 0 0;
  max-width: 720px;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.history-shell__body {
  padding-top: 8px;
  padding-bottom: 36px;
}

.history-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 20px;
  padding: 18px;
  border-radius: 26px;
  border: 1px solid rgba(255, 255, 255, 0.78);
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 18px 42px rgba(148, 163, 184, 0.1);
}

.history-toolbar__left {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.history-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.history-chip--active {
  border-color: transparent;
  background: linear-gradient(135deg, #111827 0%, #334155 100%);
  color: #fff;
}

.history-search {
  display: flex;
  align-items: center;
  gap: 10px;
}
.history-search input {
  width: 280px;
  min-height: 42px;
  padding: 0 14px;
  border-radius: 14px;
  border: 1px solid rgba(203, 213, 225, 0.9);
  background: #fff;
  color: #0f172a;
  font-size: 13px;
  outline: none;
}
.history-search input:focus {
  border-color: rgba(99, 102, 241, 0.7);
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}

.history-search__btn {
  min-height: 42px;
  padding: 0 14px;
  border-radius: 14px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.history-state,
.history-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.78);
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 18px 42px rgba(148, 163, 184, 0.12);
}

.history-state__text,
.history-empty__text {
  color: #64748b;
  font-size: 14px;
}

.history-empty__icon {
  width: 52px;
  height: 52px;
  color: #cbd5e1;
}

.history-empty__title {
  margin: 10px 0 6px;
  color: #334155;
  font-size: 18px;
  font-weight: 700;
}

.history-table {
  overflow: hidden;
  border-radius: 26px;
  border: 1px solid rgba(255, 255, 255, 0.82);
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 18px 42px rgba(148, 163, 184, 0.12);
}
.history-table table {
  width: 100%;
  border-collapse: collapse;
}
.history-table thead tr {
  background: rgba(248, 250, 252, 0.95);
}
.history-table th,
.history-table td {
  padding: 15px 18px;
  text-align: left;
  font-size: 13px;
}
.history-table th {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.history-table tbody tr + tr {
  border-top: 1px solid rgba(241, 245, 249, 0.95);
}
.history-table tbody tr:hover {
  background: rgba(248, 250, 252, 0.9);
}

.history-table__title span {
  color: #0f172a;
  font-weight: 600;
  cursor: pointer;
}

.history-table__actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.history-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.history-status--done {
  background: rgba(220, 252, 231, 0.92);
  color: #15803d;
}

.history-status--draft {
  background: rgba(254, 249, 195, 0.92);
  color: #a16207;
}

.history-mini-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: #fff;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.history-mini-btn--red {
  color: #dc2626;
}

.history-mini-btn--blue {
  color: #2563eb;
}

.history-mini-btn--green {
  color: #047857;
}

.history-mini-btn--danger {
  color: #b91c1c;
}

.history-mobile-card {
  padding: 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.82);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 14px 30px rgba(148, 163, 184, 0.12);
}

.history-mobile-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.history-mobile-card__title {
  margin: 0;
  color: #0f172a;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 700;
}

.history-mobile-card__meta,
.history-mobile-card__date {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 12px;
}

.history-mobile-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.history-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
}

.history-page {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.84);
  color: #475569;
  font-size: 13px;
  font-weight: 700;
}

.history-page--active {
  border-color: transparent;
  background: linear-gradient(135deg, #111827 0%, #334155 100%);
  color: #fff;
}

@media (max-width: 960px) {
  :host {
    --page-white-zone: 300px;
  }
  .history-toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  .history-search {
    width: 100%;
  }
  .history-search input {
    width: 100%;
    min-width: 0;
  }
}
@media (max-width: 640px) {
  :host {
    --page-white-zone: 260px;
  }
  .history-wrap {
    padding: 0 14px;
  }
  .history-shell__body {
    padding-top: 4px;
  }
  .history-topbar__inner {
    padding: 22px 18px;
  }
  .history-title {
    font-size: 24px;
  }
  .history-subtitle {
    font-size: 13px;
  }
}`],
})
export class PageDocsHistoryComponent implements OnInit {
    public documents: any[] = [];
    public loading: boolean = true;
    public page: number = 1;
    public dump: number = 20;
    public total: number = 0;
    public statusFilter: string = '';
    public searchText: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const res = await wiz.call("list", {
            page: this.page,
            dump: this.dump,
            status: this.statusFilter,
            text: this.searchText
        });

        if (res.code === 200) {
            this.documents = res.data.data || [];
            this.total = res.data.total || 0;
        }

        this.loading = false;
        await this.service.render();
    }

    public async filterByStatus(status: string) {
        this.statusFilter = status;
        this.page = 1;
        await this.load();
    }

    public async search() {
        this.page = 1;
        await this.load();
    }

    public async onPageChange(p: number) {
        this.page = p;
        await this.load();
    }

    public editDocument(doc: any) {
        this.service.href(`/docs/form/${doc.template_id}?doc_id=${doc.id}`);
    }

    public async deleteDocument(doc: any) {
        const confirmed = await this.service.modal.warning('삭제 확인', `'${doc.title}' 문서를 삭제하시겠습니까?`);
        if (!confirmed) return;

        const res = await wiz.call("delete", { doc_id: doc.id });
        if (res.code === 200) {
            await this.service.modal.success('알림', '삭제되었습니다.');
            await this.load();
        } else {
            await this.service.modal.error('오류', res.data?.message || '삭제 실패');
        }
    }

    public async downloadDocument(doc: any, format: string) {
        const formData = new FormData();
        formData.append('doc_id', doc.id);
        formData.append('format', format);

        try {
            const response = await fetch(wiz.url('download'), {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });

            if (response.ok) {
                const responseBlob = await response.blob();
                const blob = format === 'hwpx'
                    ? new Blob([responseBlob], { type: 'application/hwp+zip' })
                    : responseBlob;
                const contentDisposition = response.headers.get('Content-Disposition') || '';
                let filename = `${doc.title || 'document'}.${format}`;
                const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/i);
                const filenameMatch = contentDisposition.match(/filename[^*][^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
                if (filenameStarMatch && filenameStarMatch[1]) {
                    filename = decodeURIComponent(filenameStarMatch[1]);
                } else if (filenameMatch && filenameMatch[1]) {
                    filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
                }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }, 0);
            } else {
                let message = '다운로드 실패';
                try {
                    const errorData = await response.clone().json();
                    message = errorData?.message || errorData?.data?.message || message;
                } catch (_error) {
                    const errorText = await response.text();
                    if (errorText) {
                        message = errorText;
                    }
                }
                await this.service.modal.error('오류', message);
            }
        } catch (e: any) {
            await this.service.modal.error('오류', e.message || '다운로드 중 오류 발생');
        }
        await this.service.render();
    }

    public get totalPages() {
        return Math.ceil(this.total / this.dump) || 1;
    }

    public get pages() {
        const arr = [];
        for (let i = 1; i <= this.totalPages; i++) {
            arr.push(i);
        }
        return arr;
    }
}

export default PageDocsHistoryComponent;